const JobFilterTypes = {
  TEXT: "searchString"
};

module.exports = JobFilterTypes;



// WEBPACK FOOTER //
// ./src/js/constants/JobFilterTypes.js